import { render } from "./NavProfilMenu.vue?vue&type=template&id=4afbb895&scoped=true"
import script from "./NavProfilMenu.vue?vue&type=script&lang=js"
export * from "./NavProfilMenu.vue?vue&type=script&lang=js"

import "./NavProfilMenu.vue?vue&type=style&index=0&id=4afbb895&lang=scss&scoped=true"
import "./NavProfilMenu.vue?vue&type=style&index=1&id=4afbb895&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4afbb895"]])

export default __exports__